module.exports = __webpack_public_path__ + "img/eKmJQTJm.ebc2af2a.svg";